import Swiper from 'swiper';
import { Pagination, Autoplay, EffectFade, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';

const syncHeroSlideVideos = (swiper) => {
  swiper.slides.forEach((slideEl) => {
    const video = slideEl.querySelector('.hero__bg-video');
    if (!video) return;

    if (slideEl.classList.contains('swiper-slide-active')) {
      video.currentTime = 0;
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  });
};

const initHeroSwiper = () => {
  const el = document.querySelector('.hero.swiper');
  if (!el) return;

  new Swiper(el, {
    modules: [Pagination, Autoplay, EffectFade],
    effect: 'fade',
    fadeEffect: { crossFade: true },
    loop: true,
    speed: 800,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    pagination: {
      el: '.hero__pagination',
      clickable: true,
    },
    on: {
      init: syncHeroSlideVideos,
      slideChangeTransitionStart: syncHeroSlideVideos,
    },
  });
};


const initServiciosBanner = () => {
  const items = document.querySelectorAll('.servicios__item[data-service]');
  const bgs = document.querySelectorAll('.servicios__bg[data-service]');
  if (!items.length || !bgs.length) return;

  const activateBg = (serviceId) => {
    bgs.forEach((bg) => {
      bg.classList.toggle('is-active', bg.dataset.service === serviceId);
    });
  };

  items.forEach((item) => {
    item.addEventListener('mouseenter', () => activateBg(item.dataset.service));
  });

  const itemsBar = document.querySelector('.servicios__items');
  itemsBar?.addEventListener('mouseleave', () => activateBg('1'));
};

const initProyectosSwiper = () => {
  const el = document.querySelector('.proyectos__swiper');
  if (!el) return;

  const cards = document.querySelectorAll('.proyectos__card');

  const activateCard = (index) => {
    cards.forEach((card, i) => {
      card.classList.toggle('is-active', i === index);
    });
  };

  new Swiper(el, {
    modules: [Pagination, Navigation],
    loop: true,
    speed: 800,
    pagination: {
      el: '.proyectos__pagination',
      clickable: true,
    },
    navigation: {
      prevEl: '.proyectos__nav-prev',
      nextEl: '.proyectos__nav-next',
    },
    on: {
      slideChange(swiper) {
        activateCard(swiper.realIndex);
      },
    },
  });
};

const initCertificadosSwiper = () => {
  const el = document.querySelector('.certificados__swiper');
  if (!el) return;

  new Swiper(el, {
    modules: [Pagination, Autoplay, EffectFade],
    effect: 'fade',
    fadeEffect: { crossFade: true },
    loop: true,
    speed: 800,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    pagination: {
      el: '.certificados__swiper-pagination',
      clickable: true,
    },
  });
};

const initClientesSwiper = () => {
  const el = document.querySelector('.clientes__swiper');
  if (!el) return;

  new Swiper(el, {
    modules: [Pagination, Autoplay],
    slidesPerView: 'auto',
    loop: true,
    speed: 600,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    pagination: {
      el: '.clientes__logos-pagination',
      clickable: true,
    },
  });
};

export const initHome = () => {
  if (!document.querySelector('.hero')) return;
  initHeroSwiper();
  initServiciosBanner();
  initProyectosSwiper();
  initCertificadosSwiper();
  initClientesSwiper();
};
